var exports = {
  "kL": "ChannelDivider.module__container___dzdHZm",
  "JW": "ChannelDivider.module__unreadContainer___dzdHZm",
  "iN": "ChannelDivider.module__unreadDate___dzdHZm",
  "n8": "ChannelDivider.module__line___dzdHZm",
  "Qq": "ChannelDivider.module__text___dzdHZm",
  "KQ": "ChannelDivider.module__unreadLine___dzdHZm",
  "vD": "ChannelDivider.module__dateWithUnreadText___dzdHZm",
  "HN": "ChannelDivider.module__unreadBadge___dzdHZm",
};

module.exports = exports;
